import { getViewUnit } from "../domain/storage/viewsStore";
import { DataSample } from "../domain/types";
import { convertUnits } from "../domain/utils";
import { apiGet } from "./api";

function formatDateToIso(date: Date) {
	if (typeof (date) !== typeof (Date)) {
		date = new Date(date);
	}
	return date.toISOString();
}

export async function getLatestValues(): Promise<DataSample[] | null> {
	return apiGet<DataSample[]>("values/latest/all");
}

export async function getHistoricalDataOld(stationId: string, mvId: string, fromDate: Date, toDate: Date | null): Promise<DataSample[] | null> {
	try {
		return apiGet<DataSample[]>(`values/${stationId.toUpperCase()}/${mvId.toUpperCase()}/log?includeInvalid=false&from=${formatDateToIso(fromDate)}${toDate ? "&to=" + formatDateToIso(toDate) : ""}`);
	} catch (error) {
		return null;
	}
}
export async function getHistoricalData(stationId: string,mvId: string,	fromDate: Date,	toDate: Date | null): Promise<DataSample[] | null> {
	try {
		const samples = await apiGet<DataSample[]>(
			`values/${stationId.toUpperCase()}/${mvId.toUpperCase()}/log?includeInvalid=false&from=${formatDateToIso(fromDate)}${toDate ? "&to=" + formatDateToIso(toDate) : ""}`
		)

		if (!samples) {
			return null
		}

		return samples.map((sample) => {
			const newUnit = getViewUnit(sample.Type, sample.Unit)

			if (newUnit === sample.Unit) {
				return sample
			}

			return {
				...sample,
				Value: convertUnits(sample.Unit, newUnit, sample.Value) ?? sample.Value,
				Unit: newUnit,
			}
		})
	} catch (error) {
		return null
	}
}